<form (ngSubmit)="submit()" [formGroup]="form">
  <div class="row justify-content-center" [class.justify-content-start]="isSettings">
    <div class="col-md-12" [class.col-lg-12]="isSettings">
      <div class="form-group">
        <div
          class="tw-flex tw-flex-wrap lg:tw-flex-row"
          [class.tw-justify-center]="!isSettings || !isCompanyRep"
          [class.tw-justify-start]="isCompanyRep && isSettings"
        >
          @for (investorType of selectedInvestorType; track investorType) {
            <div class="col-md-{{ selectedInvestorType.length === 2 ? '5' : '4' }}">
              <div
                class="card mb-3 tw-cursor-pointer tw-border-2 tw-transition tw-duration-100 tw-ease-in-out hover:tw-border-[#b9adae]"
                [class.active]="form.controls.investorType?.value === investorType.id"
                [style.border-color]="
                  form.controls.investorType?.value === investorType.id ? '#C01E27' : ''
                "
                (click)="selectInvestor(investorType.id)"
              >
                <div class="card-body tw-px-8">
                  <div class="tw-my-3 tw-flex tw-flex-col tw-items-center">
                    @if (!isCompanyRep) {
                      <div
                        class="tw-mb-2 tw-inline-block tw-rounded-lg tw-bg-[#EAEAEA] tw-px-2 tw-text-[0.66rem] tw-uppercase"
                      >
                        {{ investorType.tier | translate }}
                      </div>
                    }
                    <div
                      class="tw-mb-5 tw-text-center tw-font-['Poppins'] tw-text-3xl tw-font-light tw-text-black"
                    >
                      {{ investorType.name | translate }}
                    </div>
                  </div>
                  @if (investorType.limit && investorType.limit !== 'registerInvestor.unlimited') {
                    <div
                      class="tw-max-h-[230px] tw-text-sm tw-font-light tw-text-black md:tw-min-h-[230px]"
                    >
                      <div class="tw-mb-2 tw-text-sm tw-font-semibold tw-text-black">
                        {{ 'registerInvestor.annualInvestmentLimit' | translate }}
                      </div>
                      @if (investorType.limit.ecf) {
                        <div>
                          <img
                            src="assets/img/icons/common/check_icon_green.png"
                            alt="check"
                            class="tw-pr-2"
                          />
                          {{ 'registerInvestor.ecf' | translate }}
                          <ul>
                            @if (investorType.limit.ecf.perIssuer) {
                              <div>
                                <li class="tw-text-sm">
                                  {{ investorType.limit.ecf.perIssuer | translate }}
                                </li>
                              </div>
                            }
                            <li class="tw-text-sm">
                              {{ investorType.limit.ecf.total | translate }}
                            </li>
                          </ul>
                        </div>
                      }
                      @if (investorType.limit.tcf) {
                        <div>
                          <img
                            src="assets/img/icons/common/check_icon_green.png"
                            alt="check"
                            class="tw-pr-2"
                          />
                          {{ 'registerInvestor.tcf' | translate }}
                          <ul>
                            @if (investorType.limit.tcf.perIssuer) {
                              <div>
                                <li class="tw-text-sm">
                                  {{ investorType.limit.tcf.perIssuer | translate }}
                                </li>
                              </div>
                            }
                            <li class="tw-text-sm">
                              {{ investorType.limit.tcf.total | translate }}
                            </li>
                          </ul>
                        </div>
                      }
                    </div>
                  }
                  @if (investorType.limit === 'registerInvestor.unlimited') {
                    <div class="tw-text-sm tw-font-light tw-text-black md:tw-min-h-[230px]">
                      <div class="tw-mb-2 tw-text-sm tw-font-semibold tw-text-black">
                        {{ 'registerInvestor.annualInvestmentLimit' | translate }}
                      </div>
                      <img
                        src="assets/img/icons/common/check_icon_green.png"
                        alt="check"
                        class="tw-pr-2"
                      />
                      {{ 'registerInvestor.unlimited' | translate }}
                    </div>
                  }
                  <hr />
                  <div
                    class="max-sm:tw-min-h-full md:tw-min-h-[390px]"
                    [class.md:tw-min-h-[390px]]="!isCompanyRep"
                    [class.md:tw-min-h-[250px]]="isCompanyRep"
                  >
                    <div class="tw-md-2 tw-text-sm tw-font-semibold tw-text-black">
                      {{ 'registerInvestor.conditions' | translate }}
                    </div>
                    @for (
                      condKey of objectKeys(investorType.condition);
                      track condKey;
                      let i = $index
                    ) {
                      <div class="tw-my-2 tw-text-sm tw-font-light tw-text-black">
                        <div class="tw-flex tw-items-start">
                          <img
                            src="assets/img/icons/common/check_icon_green.png"
                            alt="check"
                            class="tw-py-1 tw-pr-2"
                          />
                          {{ investorType.condition[condKey] | translate }}
                        </div>
                        @if (
                          investorType.subCondition && i === investorType.subConditionPosition - 1
                        ) {
                          <ul>
                            @for (
                              subCondKey of objectKeys(investorType.subCond);
                              track subCondKey
                            ) {
                              <li class="tw-text-sm tw-font-light tw-text-black">
                                {{ investorType.subCond[subCondKey] | translate }}
                              </li>
                            }
                          </ul>
                        }
                      </div>
                    }
                  </div>
                  <div class="tw-mb-4 tw-mt-10 tw-flex tw-justify-center">
                    <div
                      class="btn tw-w-40"
                      [class.btn-primary]="form.controls.investorType?.value === investorType.id"
                      [class.btn-primary-border]="
                        form.controls.investorType?.value !== investorType.id
                      "
                      (click)="selectInvestor(investorType.id)"
                    >
                      @if (form.controls.investorType?.value === investorType.id) {
                        {{ 'registerInvestor.selected' | translate }}
                      }
                      @if (form.controls.investorType?.value !== investorType.id) {
                        {{ 'registerInvestor.select' | translate }}
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="tw-flex tw-items-center tw-border-b tw-border-t tw-border-divider tw-py-5">
    <mat-slide-toggle formControlName="isAnonymous"></mat-slide-toggle>
    <div
      class="tw-ml-4 tw-text-sm tw-text-black"
      [innerHTML]="'registerInvestor.investAsAnAnonymous' | translate"
    ></div>
  </div>
  <div class="tw-flex tw-items-center tw-pt-5">
    <mat-checkbox formControlName="isAccept" class="tw-mr-[8px]"></mat-checkbox>
    <label class="tw-m-0 tw-ml-4 tw-text-sm tw-text-black">{{
      'registerInvestor.declare' | translate
    }}</label>
  </div>
  <div class="tw-flex tw-w-full tw-justify-center" [class.justify-content-start]="isSettings">
    <button type="submit" class="btn btn-primary tw-mt-5 tw-w-3/4" id="confirmButton">
      @if (isSettings) {
        {{ 'registerInvestor.confirmChanges' | translate }}
      }
      @if (!isSettings) {
        {{ 'registerInvestor.confirm' | translate }}
      }
    </button>
  </div>
</form>
